/**
 * Creates an object composed of all but the omitted properties from the `source` object.
 * @example
 * const object = { foo: 0, bar: 1, baz: 2 };
 * omit(object, ['bar', 'baz']);
 * // => { foo: 0 }
 *
 * @function omit
 * @param {Object} source The object to omit from.
 * @param {(string[]|string)} path The property path(s) to omit.
 * @return {Object} Returns an object without the omitted properties.
 */
export default function omit(source, path) {
	if (!path || !path.length || !source) return source;

	const values = {};
	const paths = typeof path === 'string' ? [path] : path;
	const {length: pathLength} = paths;
	for (const key in source) {
		let shouldOmit = false;
		for (let i = 0; i < pathLength; i++) {
			if (key === paths[i]) shouldOmit = true;
		}

		if (!shouldOmit) values[key] = source[key];
	}

	return values;
}
